module.exports = __webpack_public_path__ + "static/media/Screening2.defe59c8.svg";